import React from 'react';

import {
  RestaurantHelpers,
} from '@arreeba/ristoranti-frontend-lib';

import List from '../../components/list';
import RestaurantRow from '../../components/restaurant-row';
import Url from '../../lib/url';
import BackButton from '../../components/back-button';
import ButtonsContainer from '../../components/buttonsContainer';


const OrderTakeAway = (props) => {
  const restaurants = props.app.merchant.restaurants;
  return (
    <main>
      <p>Scegli il ristorante presso il quale vuoi ordinare</p>
      <List>
        {restaurants.map((res) => {
          return (
            <RestaurantRow
              key={res.id}
              restaurant={res}
              availability={RestaurantHelpers.hasOnlineService(res, 'takeAway')}
              href={Url.orderTakeAway(props.url.appId)}
            />
          );
        })}
      </List>
      <ButtonsContainer>
        <BackButton to={Url.order(props.url.appId)} />
      </ButtonsContainer>
    </main>
  );
};

export default OrderTakeAway;



// WEBPACK FOOTER //
// ./src/containers/order/order-takeaway.js